export const WS_ACTIONS = {
  authorize: 'authorize',
  getChats: 'getChats',
  getUnreadCount: 'getUnreadCount',
  getMessages: 'getMessages',
  getPhones: 'getPhones',
  sendMessage: 'sendMessage',
  unreadMessage: 'unreadMessage',
  statusMessage: 'statusMessage',
  postUpdateStatus: 'postUpdateStatus',
  updateBlockUser: 'updateBlockUser',
} as const;

export const RETRY_CONFIG = {
  MAX_TRIES: 5,
  DELAY_UNIT_MS: 1000,
} as const;

export const WS_FETCH_LIMIT = 50;

/**
 * Evento global ouvido pelo Header (shared-ui ≥ 0.1.23) pra re-buscar o total de
 * não-lidas após uma leitura local no chat — assim o badge do Header acompanha sem
 * integração específica por tela. Mesmo contrato de CHAT_UNREAD_CHANGED_EVENT da
 * shared-ui. ANCR-5329.
 */
export const CHAT_UNREAD_CHANGED_EVENT = 'wm:chat-unread-changed';
